import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

type Props = {
  children?: React.ReactNode
}

export const DialogForm: FC<Props> = ({ children }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Text variant="display-sm">Konfirmasi data atasan Anda</Text>
        <Text color="subdued" className="!font-normal">
          Pastikan Data Tim Kerja (Pengawas Sekolah) dan Data Daerah Dinas
          Pendidikan sudah sesuai.
        </Text>
      </div>

      {children}
    </div>
  )
}
